var map = {
	"./corkboard-texture.jpg": 489,
	"./table-texture.jpg": 490,
	"./texture_cinderblock_pattern_tile.jpg": 491,
	"./thumbtack.png": 69,
	"./thumbtack_tail.png": 492,
	"./web_corkboard_photo_abramoff.jpg": 493,
	"./web_corkboard_photo_akhmetshin.jpg": 494,
	"./web_corkboard_photo_behrends.jpg": 495,
	"./web_corkboard_photo_flynn_guilty.jpg": 496,
	"./web_corkboard_photo_johnson.jpg": 497,
	"./web_corkboard_photo_manafort.jpg": 498,
	"./web_corkboard_photo_manafort_guilty.jpg": 499,
	"./web_corkboard_photo_prince.jpg": 500,
	"./web_corkboard_photo_putin.jpg": 501,
	"./web_corkboard_photo_rohrabacher.jpg": 502,
	"./web_corkboard_photo_veselnitskaya.jpg": 503,
	"./web_corkboard_title_tornpaper.png": 206
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 512;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*$
// module id = 512
// module chunks = 0